import React, { useState, useEffect } from "react";
import {
  cancelarSubcripcion,
  GenerarSubcripcion,
  enviarSubscripcion,
  tieneSubcripcion,
} from "../../../utils/Notificaciones";

import "./settings.css";

export default function Settings(props) {
  const { language, alto } = props;
  const [setting, setSetting] = useState({
    language: language,
    soundChecked: localStorage.getItem("sound") === "true" ? true : false,
    notification: false,
  });

  useEffect(() => {
    tieneSubcripcion(setting, setSetting);
  }, []);

  const changeSound = (e) => {
    setSetting({ ...setting, soundChecked: e.target.checked });
    localStorage.setItem("sound", e.target.checked);
  };

  const changeNotification = (e) => {
    if (e.target.checked) {
      GenerarSubcripcion().then((result) => {
        enviarSubscripcion(result);
        setSetting({ ...setting, notification: true });
      });
    } else {
      cancelarSubcripcion(setSetting, setting);
    }
  };

  return (
    <div className='settings_contenedor'>
      <div className='settings_contenido'>
        <div className='settings_card'>
          <div className='settings_item'>
            <div className='settings_item_icon'>
              <i className='material-icons'>volume_up</i>
            </div>
            <div className='settings_item_label'>
              {setting.language === "en" ? "Sound" : "Sonido"}
            </div>
            <div className='settings_item_control'>
              <div className='switch'>
                <label>
                  <input
                    type='checkbox'
                    checked={setting.soundChecked}
                    onChange={changeSound}
                  />
                  <span className='lever'></span>
                </label>
              </div>
            </div>
          </div>

          <div className='settings_item'>
            <div className='settings_item_icon'>
              <i className='material-icons'>notifications</i>
            </div>
            <div className='settings_item_label'>
              {setting.language === "en" ? "Notifications" : "Notificaciones"}
            </div>
            <div className='settings_item_control'>
              <div className='switch'>
                <label>
                  <input
                    type='checkbox'
                    checked={setting.notification}
                    onChange={changeNotification}
                  />
                  <span className='lever'></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
